import React from "react";
import "../assets/css/finacialAid.css";
import SubHero from "../components/SubHero";
import MultipleForm from "../components/MultipleForm";
import { Box, Container } from "@mui/material";

const FinancialAid = () => {
  return (
    <>
      <SubHero name="financial-aid" />
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          margin: "80px auto",
        }}
      >
        <Box sx={{ maxWidth: 700, width: "90%", margin: "0 auto" }}>
          <MultipleForm />
        </Box>
      </Container>
    </>
  );
};

export default FinancialAid;
